import { primaryBlueColor } from "../../../utils/styles";
const paginationStyles = {
  pageBtn: {
    display: "flex",
    marginTop: "8px",
    justifyContent: "end",
    "& .Mui-selected": {
      color: "#fff",
      backgroundColor: `${primaryBlueColor} ! important`,
    },
  },
  footer:{
    position: "sticky",
    width: "100%",
    bottom: "0",
    background: "#f7f7f7",
    borderTop: "1px solid #E7E7EA",
    padding: "5px",
    height:"48px",
    display:"flex",
    justifyContent:"end",
  },
  footerRight: {
    display: 'flex',
    justifyContent: 'flex-end',
    fontSize: '11px',
    alignItems: 'center'
  },
  font:{
    "& .MuiPaginationItem-root":{
      fontSize:"13px"
    }
  },
  menuItem :{
   
    fontSize:"13px"
  
},
} as const;
export default paginationStyles;
